import React from 'react';
import { ShoppingCart, Megaphone, Store, Briefcase, Check, Star } from 'lucide-react';
import { services } from '../mock';

const serviceIcons = {
  1: ShoppingCart,
  2: Megaphone,
  3: Store,
  4: Briefcase
};

const Services = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">Our Services</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Professional digital services to help your business succeed online
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service) => {
            const Icon = serviceIcons[service.id];
            return (
              <div
                key={service.id}
                className={`relative bg-[var(--bg-card)] border-2 rounded-2xl p-8 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 ${
                  service.featured
                    ? 'border-[var(--accent-primary)] shadow-lg'
                    : 'border-[var(--border-light)] hover:border-[var(--accent-primary)]'
                }`}
              >
                {/* Featured Badge */}
                {service.featured && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <div
                      className="px-6 py-2 rounded-full flex items-center gap-2 shadow-md"
                      style={{ background: 'var(--gradient-button)' }}
                    >
                      <Star size={16} color="white" fill="white" />
                      <span className="text-white font-semibold text-sm">Most Popular</span>
                    </div>
                  </div>
                )}

                {/* Icon & Price */}
                <div className="flex items-start justify-between mb-6">
                  <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center"
                    style={{
                      background: service.featured
                        ? 'var(--gradient-button)'
                        : 'var(--accent-wash)'
                    }}
                  >
                    <Icon
                      size={32}
                      style={{ color: service.featured ? 'white' : 'var(--accent-text)' }}
                    />
                  </div>
                  <div className="text-right">
                    <div
                      className="text-3xl font-bold"
                      style={{ color: 'var(--accent-text)' }}
                    >
                      {service.price}
                    </div>
                    {service.priceNote && (
                      <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>
                        {service.priceNote}
                      </p>
                    )}
                  </div>
                </div>

                {/* Title & Description */}
                <h3 className="heading-3 mb-3">{service.title}</h3>
                <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
                  {service.description}
                </p>

                {/* Features List */}
                <div className="mb-8">
                  <p
                    className="font-semibold mb-4 text-sm uppercase tracking-wide"
                    style={{ color: 'var(--accent-text)' }}
                  >
                    What's Included:
                  </p>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <Check
                          size={18}
                          className="mr-3 mt-0.5 flex-shrink-0"
                          style={{ color: 'var(--accent-text)' }}
                        />
                        <span className="body-medium text-sm" style={{ color: 'var(--text-body)' }}>
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA Button */}
                <button
                  onClick={scrollToContact}
                  className={`w-full ${service.featured ? 'btn-primary' : 'btn-secondary'}`}
                >
                  Get Started Now
                </button>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
            Need a custom package? Let's discuss your specific requirements
          </p>
          <button onClick={scrollToContact} className="btn-primary">
            Get Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
